<div class="modal"
     [ngClass]="{'show' :config?.showOrderPincode}">

  <div class="modal-content">
    <div class="modal-content__body-container" *ngIf="!activationPending">
      <div class="modal-header">
        <h3 [translate]="titleKey" class="no-margin-buttom"></h3>
        <img *ngIf="config.showLogo" src="{{logoUrl}}" class="modal-logo">
      </div>
      <p [translate]="pincodeDescriptionKey" [translateParams]="{packageName: getPackageName()}"></p>
      <form *ngIf="!suspension">
        <div class="pin-inputs-container" [ngClass]="{pincodeIncorrect : pincodeIncorrect ? 'incorrect' : ''}">
          <app-input-pincode [x]="0" [y]="0" [omapiId]="order? order.packOmapiId: undefined"
                             [ownerComponent]="componentName"
                             [pincodeIncorrect]="pincodeIncorrect" (emitPin)="pinReceived($event)"
                             (emitPinRemoved)="pinRemoved()"
                             (emitOnBack)="onBack()"></app-input-pincode>
          <app-input-pincode [x]="1" [y]="0" [omapiId]="order? order.packOmapiId: undefined"
                             [ownerComponent]="componentName"
                             [pincodeIncorrect]="pincodeIncorrect" (emitPin)="pinReceived($event)"
                             (emitPinRemoved)="pinRemoved()"
                             (emitOnBack)="onBack()"></app-input-pincode>
          <app-input-pincode [x]="2" [y]="0" [omapiId]="order? order.packOmapiId: undefined"
                             [ownerComponent]="componentName"
                             [pincodeIncorrect]="pincodeIncorrect" (emitPin)="pinReceived($event)"
                             (emitPinRemoved)="pinRemoved()"
                             (emitOnBack)="onBack()"></app-input-pincode>
          <app-input-pincode [x]="3" [y]="0" [omapiId]="order? order.packOmapiId: undefined"
                             [ownerComponent]="componentName"
                             [pincodeIncorrect]="pincodeIncorrect" (emitPin)="pinReceived($event)"
                             (emitPinRemoved)="pinRemoved()"
                             (emitOnBack)="onBack()"></app-input-pincode>
        </div>
      </form>
      <span *ngIf="suspension" class="errorText"
            [innerHTML]="pincodeRemainingTimeKey | translate:{timeRemaining: suspensionExpiration}"></span>
      <span *ngIf="pincodeIncorrect && !suspension" class="errorText"
            [innerHTML]="pincodeIncorrectKey | translate:{numberOfTimeLeft: numberOfTimeLeft}"></span>
      <app-spacer [spacerSize]="20"></app-spacer>
      <p class="hint" [translate]="infoKey" *ngIf="config.showHintInfoKey"></p>

      <div>
        <app-navigable-button class="btn-as-link" [class.hint-active]="showHint"
                              [x]="0" [y]="1" [ownerComponent]="componentName" (emitOnEnterPressed)="toggleHint()"
                              (emitOnBack)="onBack()">
          <span [translate]="'eos-tv-shop-ii.text.input-pincode-show-hint'"></span>
        </app-navigable-button>

        <p class="hint animation--fade-in" *ngIf="showHint" [translate]="'eos-tv-shop-ii.text.input-pincode-hint'"></p>
      </div>
      <app-navigable-button [x]="0" [y]="2" [ownerComponent]="componentName" class="btn-grey"
                            (emitOnEnterPressed)="onEmitOpenConditions()" (emitOnBack)="onBack()">
        <span [translate]="watchConditionsButtonText"></span>
      </app-navigable-button>
    </div>
    <div class="modal-content__body-container" *ngIf="activationPending">
      <div class="empty-container">
        <app-spinner-loader class="intern"></app-spinner-loader>
      </div>
    </div>
  </div>
</div>
